/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class IsVPN extends RiskFactor {
    icon = 'close-s';

    className = 'icon-red';

    label = 'Order Placed From';

    result = 'Vpn';

    static getCondition({isVpn}) {
        return !!isVpn;
    }

    parse({isVpn}) {
        this.isVpn = isVpn;
    }

    getResult() {
        return this.result;
    }
}
